import TrackedLink from "@/components/TrackedLink";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const CTASection = () => {
  return (
    <section className="py-20 md:py-28">
      <div className="container">
        <div
          className="relative overflow-hidden rounded-2xl bg-hero-gradient px-6 py-16 text-center md:px-16 md:py-20 animate-fade-in"
        >
          <div className="pointer-events-none absolute -left-20 -top-20 h-64 w-64 rounded-full bg-primary-foreground/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-20 -right-20 h-64 w-64 rounded-full bg-primary-foreground/10 blur-3xl" />

          <div className="relative">
            <h2 className="text-3xl font-bold text-primary-foreground md:text-4xl">
              Klaar om over te stappen?
            </h2>
            <p className="mx-auto mt-4 max-w-lg text-lg text-primary-foreground/80">
              Bereken in 2 minuten wat jouw IT gaat kosten. Transparant, eerlijk en zonder verplichtingen.
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Button
                size="lg"
                className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 font-semibold text-base"
                asChild
              >
                <TrackedLink to="/configurator" trackLabel="Bereken je prijs" trackLocation="cta_section">
                  Bereken je prijs
                  <ArrowRight className="ml-1 h-4 w-4" />
                </TrackedLink>
              </Button>
              <Button
                size="lg"
                className="border-2 border-primary-foreground bg-primary-foreground/15 text-primary-foreground hover:bg-primary-foreground/25 font-semibold text-base"
                asChild
              >
                <TrackedLink to="/contact" trackLabel="Neem contact op" trackLocation="cta_section">Neem contact op</TrackedLink>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
